module.exports = __webpack_public_path__ + "img/canales-472.0f9d82df.svg";